<template>
  <div></div>
</template>

<script>
import pdfMake from "pdfmake";
import htmlToPdfmake from "html-to-pdfmake";
import pdfFonts from "../../../../assets/build/vfs_fonts";

import apiConfig from "../../../../config/api";
import whApi from "@/api/warehouse/";

import moment from "moment";

import { Decode, Encode } from "@/services";
import userApi from "@/api/user/";
import { toFixed } from "ant-design-vue/lib/input-number/src/utils/MiniDecimal";

import { ArabicNumberToText } from "../../../../utils/numberToText";

import JsBarcode from "jsbarcode/bin/JsBarcode";

import numbro from "numbro";

export default {
  props: {
    dataExportPdf: Object,
  },
  data: () => ({
    jsonExport: [],

    newDataTable: [],

    user: "",
    numberToTh: "",
  }),
  async created() {
    await this.getAllMainPd();
    await this.getAllSubPd();
    await this.groupDateExport();
  },

  methods: {
    groupDateExport() {
      let newMainPd = {};
      let newSubPd = {};

      this.dataExportPdf.forEach((element, index) => {
        console.log({ element });
        newMainPd = this.mainProduct.find(
          (data) => data.id === element.mainProductGroupId
        );

        newSubPd = this.subProduct.find(
          (data) => data.id === element.subProductGroupId
        );

        !newMainPd
          ? ""
          : !newSubPd
          ? ""
          : this.jsonExport.push({
              no: index + 1,
              productCode: element.product_code,
              productName: element.product_name,
              productBarcode: element.product_barcode,
              mainProduct: newMainPd.main_product_group_name,
              subProduct: newSubPd.sub_product_group_name,
              unit: element.unit
                ? `${element.unit.unit_name} (${element.unit.unit_code})`
                : "",
              costPrice: element.product_cost_price,
              wholesalePrice: element.product_wholesale_price,
              profit:
                element.product_wholesale_price - element.product_cost_price,
              productMix: element.product_min_stock,
              productMax: element.product_max_stock,
              is_cancel: element.is_cancel,
            });
      });

      this.setDataToTable();
    },

    async getAllMainPd() {
      // this.loading = true;
      let responseData = {};
      try {
        responseData = await whApi.mainProduct.getAll();
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.mainProduct = responseData.data;
        // this.loading = false;
      }
    },

    async getAllSubPd() {
      // this.loading = true;
      let responseData = {};
      try {
        responseData = await whApi.subProduct.getAll();
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.subProduct = responseData.data;
        // this.loading = false;
      }
    },

    exports() {
      const newWindow = window.open("", "_blank");

      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        Roboto: {
          normal: "Kanit-Regular.ttf",
          bold: "Kanit-Medium.ttf",
          italics: "Kanit-Medium.ttf",
          bolditalics: "Kanit-Medium.ttf",
        },
      };

      const html = [
        {
          text: "Product Library",
          fontSize: 16,
          bold: true,
          margin: [0, 0, 0, 10],
        },

        // TABLE
        {
          table: {
            // widths: [
            //   10,
            //   10,
            //   "*",
            //   "*",
            //   "*",
            //   "*",
            //   "*",
            //   "*",
            //   "*",
            //   "*",
            //   "*",
            //   "*",
            //   "*",
            //   "*",
            //   "*",
            // ],
            body: this.newDataTable,
          },
        },
      ];

      const pdfData = {
        content: html,
        pageOrientation: "landscape",
      };
      pdfMake.createPdf(pdfData).open({}, newWindow);
      this.$emit("generatedFile");
    },

    setDataToTable() {
      this.jsonExport.forEach((element, index) => {
        if (index === 0) {
          this.newDataTable.push(
            [
              {
                fontSize: 9,
                text: "#",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "รหัสสินค้า",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "ชื่อสินค้า",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "Barcode",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "กลุ่มสินค้าหลัก",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "กลุ่มสินค้ารอง",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "หน่วยสินค้า",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "ราคาทุน",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "ราคาขาย",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "กำไร",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "Mix",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "Max",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "Status",
                alignment: "center",
              },
            ],
            [
              {
                text: element.no,
                fontSize: 9,
                fillColor: "#eaeced",
              },
              {
                text: element.productCode,
                fontSize: 9,
                fillColor: "#eaeced",
              },
              {
                text: element.productName,
                fontSize: 9,
                fillColor: "#eaeced",
              },
              {
                text: element.productBarcode,
                fontSize: 9,
                fillColor: "#eaeced",
              },
              {
                text: element.mainProduct,
                fontSize: 9,
                fillColor: "#eaeced",
              },
              {
                text: element.subProduct,
                fontSize: 9,
                fillColor: "#eaeced",
              },
              {
                text: element.unit,
                fontSize: 9,
                fillColor: "#eaeced",
              },
              {
                text: element.costPrice,
                fontSize: 9,
                fillColor: "#eaeced",
                alignment: "right",
              },
              {
                text: element.wholesalePrice,
                fontSize: 9,
                fillColor: "#eaeced",
                alignment: "right",
              },
              {
                text: element.profit,
                fontSize: 9,
                fillColor: "#eaeced",
                alignment: "right",
              },
              {
                text: element.productMix,
                fontSize: 9,
                fillColor: "#eaeced",
                alignment: "right",
              },
              {
                text: element.productMax,
                fontSize: 9,
                fillColor: "#eaeced",
                alignment: "right",
              },
              {
                text: element.is_cancel === "0" ? "ใช้งาน" : "ยกเลิกใช้งาน",
                fontSize: 9,
                fillColor: "#eaeced",
                color: element.is_cancel === "0" ? "green" : "red",
                alignment: "center",
              },
            ]
          );
        } else {
          this.newDataTable.push([
            {
              text: element.no,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
            },
            {
              text: element.productCode,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
            },
            {
              text: element.productName,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
            },
            {
              text: element.productBarcode,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
            },
            {
              text: element.mainProduct,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
            },
            {
              text: element.subProduct,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
            },
            {
              text: element.unit,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
            },
            {
              text: element.costPrice,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
              alignment: "right",
            },
            {
              text: element.wholesalePrice,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
              alignment: "right",
            },
            {
              text: element.profit,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
              alignment: "right",
            },
            {
              text: element.productMix,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
              alignment: "right",
            },
            {
              text: element.productMax,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
              alignment: "right",
            },
            {
              text: element.is_cancel === "0" ? "ใช้งาน" : "ยกเลิกใช้งาน",
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
              color: element.is_cancel === "0" ? "green" : "red",
              alignment: "center",
            },
          ]);
        }
      });

      this.exports();
    },
  },
};
</script>
